export default {
  form: {
    versions: {
      label: 'Version',
      placeholder: 'Sélectionner une version',
    },
    font_family: {
      label: 'Police de caractères',
    },
    background_color: {
      label: "Couleur d'arrière-plan",
    },
    promo_frame_primary_color: {
      label: 'Couleur du cadre promo',
    },
    promo_frame_discount_label_color: {
      label: 'Couleur de réduction du cadre promo',
    },
    vip_members_cta_color: {
      label: 'Couleur CTA membres VIP',
    },
    url_cta_color: {
      label: 'Couleur CTA URL',
    },
    url_color: {
      label: "Couleur de l'URL",
    },
    url_type: {
      label: 'URL',
      placeholder: 'Sélectionner une URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    qr_code_border_color: {
      label: 'Couleur de bordure du QR code',
    },
    qr_code_background_color: {
      label: "Couleur d'arrière-plan du QR code",
    },
    footer_background_color: {
      label: "Couleur d'arrière-plan du pied de page",
    },
    logo_zoom: {
      label: 'Taille du logo',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: "Échec du chargement de l'autocollant",
  },
};
